import React, { FC } from 'react';
import { SectionHeaderProps } from './types';
import { Text } from '@bechtel/gds';
import { BlockHeadingStyled } from './styled';

export const SectionHeader: FC<SectionHeaderProps> = ({ title }) => {
  return (
    <BlockHeadingStyled>
      <Text size="400" weight="600" family="graphik">
        {title}
      </Text>
    </BlockHeadingStyled>
  );
};
